<script>
/* Note that this creates / updates an account request and so can be used at the end of an onboard request */
import { mapActions } from 'vuex'
import { getCurrentOnBoardRequest, updateCurrentOnBoardRequest } from '@/onBoardRequest'

export default {
  name: 'GetMOU',
  props: {
    trackName: String,
  },
  data: function () {
    return {
      stepName: 'mou',
      loading: false,
      isValid: false,
      onBoardRequest: {},
      search: '',
      file: {
        name: '',
        data: '',
        stepName: '',
        trackName: '',
        category: 'MOU',
      },
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    submit() {
      this.onBoardRequest.data.request_files = []
      if (this.file.name) {
        this.onBoardRequest.setTrackStepComplete(this.trackName, this.stepName)
        this.onBoardRequest.data.request_files = [
          {
            step_name: this.stepName,
            track_name: this.trackName,
            file: this.file.name,
            category: this.file.category
          }
        ]
      }
      const me = this
      updateCurrentOnBoardRequest(me.onBoardRequest)
        .then(async (res) => {
          if (this.file.data) {
            await this.$api.loadRequestFile(this.file, me.onBoardRequest.id)
          }
          this.$api.mountNextComponent(res)
        })
        .catch(error => {
          const { response } = error
          if (response) {
            this.errors = response.data
          }
          if (response.status !== 400) {
            this.showMessage(error)
          }
        });
    },
    pickFile() {
      this.$refs.file.click()
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] === undefined) {
        this.file.name = ''
        this.file.readAsDataURL = ''
        const message = 'There is no file selected'
        this.showMessage({ message })
      } else {
        const filename = files[0].name
        this.file.name = filename
        if (this.file.name.lastIndexOf('.') <= 0) {
          const message = 'File format must have an acceptable extension (.jpg, .png, .pdf)'
          this.showMessage({ message })
        } else {
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.file.data = files[0]
            this.file.name = filename
          })
        }
      }
    },
  },
  mounted: function () {
    const me = this
    this.loading = true
    this.file.stepName = this.stepName;
    this.file.trackName = this.trackName;

    getCurrentOnBoardRequest()
      .then((res) => {
        me.onBoardRequest = res
        this.$api.setStepVisitedThisSession(this.stepName)
      })
      .catch((error) => me.showMessage(error))
  },
}
</script>
<template>
  <v-layout align-center justify-space-between row fill-height>
    <v-flex class="lg-inner">
      <h1>Memorandum of Understanding</h1><p>&nbsp;</p>
      <p>Please attach a signed MOU to upload.</p>
      <v-form id="get-mou-form" ref="getMouForm" v-model="isValid" @submit.prevent="submit">
        <v-flex>
          <v-text-field
            label="MOU file"
            @click='pickFile'
            v-model='file.name'
            prepend-icon='attach_file'
            hint="Upload MOU PDF"
            color="secondary"
          >
          </v-text-field>
          <input
            type="file"
            style="display: none"
            ref="file"
            accept="application/pdf"
            @change="(e)=>onFilePicked(e)"
          />
        </v-flex>
        <v-layout row justify-end>
          <v-btn @click.prevent="submit" role="button" class="btn" color="secondary" :disabled="!isValid">Next</v-btn>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<style lang="css" scoped>
.text-block {
  margin: 1rem 0;
}
.text-hint {
  margin-top: 2rem;
}
.text-action {
  margin-bottom: 1rem;
}
#get-mou-form {
  margin-top: 1rem;
}
.pi-admin-field {
  margin: 1rem 0;
}
</style>
